import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSystemKyc } from '../hooks/use-system-kyc.js';
import SystemKycPageView from './system-kyc-page-view.jsx';

function SystemKycPageContainer() {
  const state = useSystemKyc();
  const navigate = useNavigate();

  const openCreate = () => {
    navigate(`/system/user-settings/kyc/new${state.detailsQuery}`);
  };

  const openView = (id) => {
    navigate(`/system/user-settings/kyc/${encodeURIComponent(id)}/view${state.detailsQuery}`);
  };

  const openEdit = (id) => {
    navigate(`/system/user-settings/kyc/${encodeURIComponent(id)}/edit${state.detailsQuery}`);
  };

  return (
    <SystemKycPageView
      {...state}
      openCreate={openCreate}
      openView={openView}
      openEdit={openEdit}
    />
  );
}

export default SystemKycPageContainer;
